import {
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	LineElement,
	PointElement,
	Tooltip,
} from "chart.js";
import {Line} from "react-chartjs-2";

import {Maintenance} from "@/components/custom/MaintenanceSwitcher/MaintenanceSwitcher.jsx";
import {buildFlatGraph} from "@/helpers.js";
import {ROP_MIN_LABEL} from "@/properties.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const GI_COLOR = "rgba(220, 53, 69, 0.6)";
const GR_COLOR = "rgba(25, 135, 84, 0.6)";

function getGiValue(row) {
	return row.gi ?? 0;
}

function getGrValue(row) {
	return row.gr ?? 0;
}

export const TransactionsGraph = ({graphData, maintenance, createdDate}) => {
	const data = graphData?.length ? graphData : buildFlatGraph(createdDate);

	function getMovementDataset(label, getValue, borderColor, datasetOptions = {}) {
		return {
			label,
			data: data.map(getValue),
			borderColor,
			backgroundColor: "rgba(0, 255, 128, 0)",
			fill: false,
			...datasetOptions,
		};
	}

	function getSohDatasets() {
		return [
			getMovementDataset("SOH", v => v.stock_level, "blue", {stepped: true}),
			getMovementDataset(ROP_MIN_LABEL, v => v.rop, "rgba(0, 255, 128, 0.2)"),
			getMovementDataset("MAX", v => v.max, "rgba(255, 0, 0, 0.3)", {
				backgroundColor: "rgba(54, 162, 235,0)",
			}),
		];
	}

	function getTransactionsChartData() {
		const labels = data.map(v => v["date"]);

		if (maintenance === Maintenance.PM) {
			return {
				labels,
				datasets: [getMovementDataset("GI", getGiValue, GI_COLOR)],
			};
		}

		if (maintenance === Maintenance.CM) {
			return {
				labels,
				datasets: [
					getMovementDataset("GI", getGiValue, GI_COLOR),
					getMovementDataset("GR", getGrValue, GR_COLOR),
				],
			};
		}

		return {
			labels,
			datasets: getSohDatasets(),
		};
	}

	const options = {
		interaction: {
			intersect: false,
			axis: "x",
		},
		scales: {
			y: {
				beginAtZero: true,
				ticks: {
					stepSize: 1,
				},
			},
		},
	};

	return <Line data={getTransactionsChartData()} options={options} data-testid="transactions-graph" />;
};
